import {connect} from 'react-redux';
import {Thermocycler as Component} from './Thermocycler';
import {
  createThermocycler,
  setThermocyclerControlVisibility,
  hideAllControls,
  thermocyclerOpen,
  removeAllTubesFromThermocycler,
  setSolution,
  setModal,
  showModal,
  setSolutionInScene
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("thermocyclers") &&
     state.notebook.protocolSection.scene.apparatus.thermocyclers.some(
       thermocycler => thermocycler.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].type,
      open: state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].open,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].controlsVisible,
      numberOfSolutions: state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].numberOfSolutions,
      solutions: state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].solutions,
      altText: state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].altText
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createThermocycler: (data)=>{
      dispatch(createThermocycler(data))
    },
    setThermocyclerControlVisibility: (data)=>{
      dispatch(setThermocyclerControlVisibility(data))
    },
    hideAllControls: (data)=>{
      dispatch(hideAllControls(data))
    },
    thermocyclerOpen: (data) => {
      dispatch(thermocyclerOpen(data))
    },
    setSolution: (data) => {
      dispatch(setSolution(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    },
    removeAllTubesFromThermocycler: (data) => {
      dispatch(removeAllTubesFromThermocycler(data))
    },
    setSolutionInScene: (data) => {
      dispatch(setSolutionInScene(data))
    },
  };
}

export const Thermocycler = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
